import React, { ReactNode } from "react";

import { MainWrapperContainer } from "../../../assets/styles/theme";
import Header from "./Header";
import LeftPanel from "./LeftPanel";

interface PostLoginLayoutProps {
  children?: ReactNode;
  noLeftPanel: any;
  childComponent?: ReactNode;
  loader: any;
}

const PostLoginLayout: React.FC<PostLoginLayoutProps> = ({
  children,
  noLeftPanel = false,
  loader = false,
  ...props
}: PostLoginLayoutProps) => {
  console.log("loader", loader)
  return (
    <>
      <Header />
      <MainWrapperContainer>
        {!noLeftPanel && !loader && <LeftPanel />}
        {props?.childComponent}
      </MainWrapperContainer>
    </>
  );
};

export default PostLoginLayout;
